import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Image from '../Image';

class ImageWithFallback extends PureComponent {
  static propTypes = {
    src: PropTypes.string,
    alt: PropTypes.string.isRequired,
    altSrc: PropTypes.string,
    fallback: PropTypes.any,
  };

  state = {
    isError: false,
    isAltSrcError: false,
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.src !== this.props.src) {
      this.setState({
        isError: false,
      });
    }
    if (nextProps.altSrc !== this.props.altSrc) {
      this.setState({
        isAltSrcError: false,
      });
    }
  }

  onError = () => {
    this.setState({
      isError: true,
    });
  };

  onAltSrcError = () => {
    this.setState({
      isAltSrcError: true,
    });
  };

  render() {
    const { src, alt, altSrc, fallback, ...other } = this.props;
    return (
      <div className="supermatch-image-with-fallback">
        {
          (() => {
            if (src && !this.state.isError) {
              return <Image src={src} alt={alt} {...other} onError={this.onError} />;
            } else if (altSrc && !this.state.isAltSrcError) {
              return <Image src={altSrc} alt={alt} {...other} onError={this.onAltSrcError} />;
            } else {
              return (fallback);
            }
          })()
        }
      </div>
    );
  }
}

export default ImageWithFallback;
